import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { dlStyles } from '../../../styles';
import type { Package } from '../entities';

@customElement('umb-market-package-sidebar-badges')
export class UmbMarketPackageSidebarBadges extends LitElement {
  @property({ type: Object })
  package?: Package;

  render() {
    if (!this.package) {
      return null;
    }

    return html`<div>
      <dl>
        <div>
          <dt>Umbraco versions</dt>
          <dd>
            <umb-market-package-version-badges
              .versionsSupported=${this.package.umbracoMajorVersionsSupported}
              .cloudCertified=${this.package.isCertifiedToWorkOnUmbracoCloud}
            ></umb-market-package-version-badges>
          </dd>
        </div>
        ${when(
          this.package?.licenseTypes.length,
          () => html` <div>
            <dt>License type</dt>
            <dd>
              <umb-market-package-badge
                .value=${this.package?.licenseTypes.join(', ')}
              ></umb-market-package-badge>
            </dd>
          </div>`
        )}
        <div>
          <dt>Package type</dt>
          <dd>
            <div id="wrapper">
              <umb-market-package-badge
                .value=${this.package.packageType}
              ></umb-market-package-badge>

              <umb-market-package-owner-badge
                .package=${this.package}
              ></umb-market-package-owner-badge>
            </div>
          </dd>
        </div>
      </dl>
    </div> `;
  }

  static styles = [
    dlStyles,
    css`
      :host {
        display: block;
      }

      dt {
        margin-bottom: var(--xs-spacer);
      }

      #wrapper {
        display: flex;
        gap: var(--xs-spacer);
        position: relative;
      }
    `,
  ];
}
